import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useInitData } from 'queries/initial-data';
const InitialAppFetch = ()=>{
    useInitData();
    return /*#__PURE__*/ _jsx(_Fragment, {});
};
export { InitialAppFetch };
